import * as SidebarLink from 'components/sidebar/SidebarLink';
import { useTaskDrawerState } from 'components/tasks/useTaskDrawerState';
import { IntercomProductTourTargets } from 'constants/intercom';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';

const TasksLinks = () => {
    const { accountId, hasGivebutterPlusAccess } = useCurrentAccount();
    const { setIsDrawerOpen } = useTaskDrawerState();
    const linkPath = `/accounts/${accountId}/tasks`;

    return (
        <SidebarLink.Link
            to={linkPath}
            data-intercom-target={IntercomProductTourTargets.SidebarTasksLink}
            onClick={e => {
                if (hasGivebutterPlusAccess) {
                    e.preventDefault();
                    setIsDrawerOpen(true);
                }
            }}
        >
            <SidebarLink.LevelOne icon="tasks" isActive={location.pathname.includes(linkPath)}>
                Tasks
            </SidebarLink.LevelOne>
        </SidebarLink.Link>
    );
};

export { TasksLinks };
